import { render } from "./HeaderComponent.vue?vue&type=template&id=60747d74&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=60747d74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60747d74"]])

export default __exports__